import { render, staticRenderFns } from "./PresetPageActionDelete.vue?vue&type=template&id=61da1293&"
import script from "./PresetPageActionDelete.vue?vue&type=script&lang=ts&"
export * from "./PresetPageActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports